import React from 'react';
import { TimeDividerStyle, TimedealTextStyle, TimedealTimeStyle, TimedealTitleStyle } from './style';

interface WidgetPreviewTimedealInfoProps {
  title: string;
  subTitle?: string;
}

const TimeDivider = () => {
  return (
    <TimeDividerStyle>
      <div className="dot" />
      <div className="dot" />
    </TimeDividerStyle>
  );
};

const WidgetPreviewTimedealInfo = (props: WidgetPreviewTimedealInfoProps): JSX.Element => {
  const { title, subTitle } = props;
  return (
    <div>
      <TimedealTextStyle>{title}</TimedealTextStyle>
      <TimedealTimeStyle>
        <span>00</span>
        <TimeDivider />
        <span>00</span>
        <TimeDivider />
        <span>00</span>
      </TimedealTimeStyle>
      {!!subTitle && <TimedealTitleStyle>{subTitle}</TimedealTitleStyle>}
    </div>
  );
};

export default WidgetPreviewTimedealInfo;
